"use client";
import React, { useCallback, useEffect } from "react";

import CartDropdown from "./CartDropdown";
import useCart from "../../../auth/hooks/useCart";
import useAppContext from "../../../theme/hooks/useAppContext";
import { usePathname } from "../../../../navigation";
import Button from "../../../theme/components/Button";
import getCartItemCount from "../../utils/getCartItemCount";

const CartSwitch = () => {
  const { cart, currentClient, refetch } = useCart();

  const pathname = usePathname();
  const cartItemCount = getCartItemCount(cart);

  const { cartDropdownView, toggleCartDropdownView } = useAppContext();

  const toggleSwitch = (e) => {
    e.stopPropagation();
    toggleCartDropdownView(!cartDropdownView ? "cart" : null);
    refetch();
  };

  const hideCart = () => {
    toggleCartDropdownView();
  };

  const handleClickOutside = useCallback(
    (event) => {
      if (!(event.target instanceof Node)) return;
      const clickedInsideCartContainer = (event.target as HTMLElement).closest(
        ".dropdown--cart",
      );

      const clickedInsideClientChooser = (event.target as HTMLElement).closest(
        ".client-list-item-wrapper",
      );

      if (
        !clickedInsideCartContainer &&
        !clickedInsideClientChooser &&
        cartDropdownView
      ) {
        hideCart();
      }
    },
    [cartDropdownView],
  );

  const handlePageShow = useCallback(
    (event) => {
      if (event.persisted) {
        console.log("Page was loaded from cache", event);
        refetch();
      }
    },
    [refetch],
  );

  useEffect(() => {
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [handlePageShow]);

  useEffect(() => {
    if (!cartDropdownView) return;
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [cartDropdownView]);

  useEffect(() => {
    toggleCartDropdownView();
  }, [pathname]);

  if (!currentClient) return null;

  return (
    <div className={`${cartDropdownView ? "open" : ""}`}>
      <Button
        appearance="link"
        data-ci="user-dropdown"
        type="button"
        onClick={toggleSwitch}
        icon="cart"
        style={{
          minWidth: "42px",
          minHeight: "42px",
        }}
      >
        <span className="position-relative d-flex justify-content-between align-items-center">
          {cartItemCount > 0 && (
            <div className="gap-2 cart-count">{cartItemCount}</div>
          )}
        </span>
      </Button>
      <CartDropdown
        cart={cart}
        currentClient={currentClient}
        hidden={!cartDropdownView}
        onClose={hideCart}
      />
    </div>
  );
};

export default CartSwitch;
